/* ==========================================================
   UNIVERSAL CLOSE FUNCTION
   ========================================================== */
function bannerHideNow() {
  const banner = document.getElementById("cookies-banner");
  // const overlay = document.querySelector(".offcanvas-cookie");

  if (banner) banner.classList.add("d-none");
  // if (overlay) overlay.style.display = "none";

  document.body.style.overflow = "visible";
}



/* ==========================================================
   COOKIE BANNER WEB COMPONENT
   ========================================================== */
class CookieBanner extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initEvents();
    this.loadFeatures();
  }

  initEvents() {
    const init = () => this.initCookieBanner();

    document.addEventListener("DOMContentLoaded", init);
    document.addEventListener("shopify:section:load", init);
  }

  loadFeatures() {
    window.Shopify.loadFeatures(
      [{ name: "consent-tracking-api", version: "0.1" }],
      (error) => {
        if (error) throw error;
        this.initCookieBanner();
      }
    );
  }

  initCookieBanner() {
    if (!(window.Shopify && window.Shopify.customerPrivacy)) {
      console.error("Shopify Privacy API missing");
      return;
    }

    const { userCanBeTracked, getTrackingConsent } = window.Shopify.customerPrivacy;
    const userConsent = getTrackingConsent();

    this.setupElements();

    if (window.Shopify.designMode || (userCanBeTracked() && userConsent === "no_interaction")) {
      this.showBanner();
    } else if (userCanBeTracked() && userConsent === "yes") {
      this.hideBanner();
    }
  }

  setupElements() {
    this.cookieBanner = document.getElementById("cookies-banner");
    this.acceptBtn = document.getElementById("cookie-accept");
    this.declineBtn = document.getElementById("cookie-decline");
    // this.overlay = document.querySelector(".offcanvas-cookie");

    if (this.acceptBtn)
      this.acceptBtn.addEventListener("click", () => this.handleConsent(true));

    if (this.declineBtn)
      this.declineBtn.addEventListener("click", () => {
        this.handleConsent(false);
        bannerHideNow();
      });
  }

  handleConsent(consent) {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      window.Shopify.customerPrivacy.setTrackingConsent(consent, () => {
        bannerHideNow();
      });
    }
  }

  hideBanner = () => {
    bannerHideNow();
  };

  showBanner = () => {
    if (this.cookieBanner)
      this.cookieBanner.classList.remove("d-none");

    // if (this.overlay)
    //   this.overlay.style.display = "block";
    document.body.style.overflow = "auto";
  };
}

customElements.define("cookie-banner", CookieBanner);



/* ==========================================================
   PREFERENCE POPUP LOGIC
   ========================================================== */
document.addEventListener("DOMContentLoaded", function () {
  const settingsBtn = document.getElementById("cookie-seeting");
  const cookieMain = document.querySelector(".cookie-main");
  // const overlay = document.querySelector(".offcanvas-cookie");

  function setupPreferences() {
    const acceptAll = document.getElementById("cookie-accept-all");
    const declineAll = document.getElementById("cookie-decline-all");
    const prefBtn = document.getElementById("cookie-preferences");
    const declineMain = document.getElementById("cookie-decline");

    // Accept All button
    if (acceptAll) {
      acceptAll.addEventListener("click", function () {
        if (window.Shopify?.customerPrivacy) {
          window.Shopify.customerPrivacy.setTrackingConsent(
            {
              analytics: true,
              marketing: true,
              preferences: true,
              sale_of_data: true,
            },
            () => {
              bannerHideNow();
            }
          );
        }
      });
    }

    // DECLINE ALL button (your custom one)
    if (declineAll) {
      declineAll.addEventListener("click", function () {
        if (window.Shopify?.customerPrivacy) {
          window.Shopify.customerPrivacy.setTrackingConsent(false, () => {
            bannerHideNow();
          });
        } else {
          bannerHideNow();
        }
      });
    }

    // SAVE PREFERENCES
    if (prefBtn) {
      prefBtn.addEventListener("click", function () {
        const necessary = document.querySelector("#necessary")?.checked ?? true;
        const marketing = document.querySelector("#marketing")?.checked ?? false;
        const analytical = document.querySelector("#analytical")?.checked ?? false;

        if (window.Shopify?.customerPrivacy) {
          window.Shopify.customerPrivacy.setTrackingConsent(
            {
              analytics: analytical,
              marketing: marketing,
              preferences: true,
              sale_of_data: necessary,
            },
            () => {
              bannerHideNow();
            }
          );
        } else {
          bannerHideNow();
        }
      });
    }
  }



  /* ========================================
     WATCH FOR PREFERENCES CLOSE BUTTON
     ======================================== */
  let interval = setInterval(() => {
    const closeBtn = document.getElementById("button-close");

    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        if (cookieMain) cookieMain.style.display = "flex";
        // if (overlay) overlay.style.display = "block";
      });

      setupPreferences();
      clearInterval(interval);
    }
  }, 500);



  /* ========================================
     SETTINGS BUTTON CLICK
     ======================================== */
  if (settingsBtn) {
    settingsBtn.addEventListener("click", () => {
      if (cookieMain) cookieMain.style.display = "none";
      // if (overlay) overlay.style.display = "none";
    });
  }
});
